<ion-grid>
  <ion-row>
    <ion-col
      *ngIf="!product?.summary?.properties?.has(productEnum.direct)"
      size-lg="8"
      size-md="6"
    >
      <ion-row class="inventory-pricing-section">
        <ion-col
          size-lg="6"
          size-md="12"
          size-xs="12"
          size-sm="12"
          class="section-separator"
        >
          <app-seller-detail-description-inventory [product]="product">
          </app-seller-detail-description-inventory>
        </ion-col>
        <ion-col
          size-lg="6"
          size-md="12"
          size-xs="12"
          size-sm="12"
          class="section-separator"
        >
          <app-seller-detail-description-pricing
            [product]="product"
            [sellerPriceDetail]="sellerPriceDetail"
          >
          </app-seller-detail-description-pricing>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col
      size-lg="4"
      size-md="6"
      size-xs="12"
      size-sm="12"
      class="section-separator"
      *ngIf="product?.summary?.poDates?.length > 0"
    >
      <app-seller-detail-decription-upcoming
        [poDates]="product?.summary?.poDates"
        [productNumber]="product?.productNumber"
      ></app-seller-detail-decription-upcoming>
    </ion-col>
  </ion-row>
</ion-grid>
